export default "__VITE_ASSET__CeDENjpa__"